import { cx } from "../../lib/cx.js";
import { createButtonComponent } from "../Button.js";
export function createAutocompleteDetachedFormContainerComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  return function AutocompleteDetachedFormContainer(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      onCancel = userProps.onCancel,
      translations = userProps.translations;
    return createElement("div", {
      className: cx('ais-AutocompleteDetachedFormContainer', classNames.detachedFormContainer)
    }, children, createElement(Button, {
      variant: "ghost",
      className: cx('ais-AutocompleteDetachedCancelButton', classNames.detachedCancelButton),
      onClick: onCancel
    }, translations.detachedCancelButtonText));
  };
}